import React, { useState, useEffect } from 'react';
import { getWallet } from '../api/api';
import { WalletOut } from '../api/types';

interface HeaderProps {
  onLoginClick: () => void;
  onRegisterClick?: () => void;
  onNavigate?: (id: string) => void;
  activePage?: string;
  onBack?: () => void;
  title?: string;
  isLogged?: boolean;
}

const Header: React.FC<HeaderProps> = ({ onLoginClick, onRegisterClick, onNavigate, activePage, onBack, title, isLogged }) => {
  const isWhite = !!title;
  const [wallet, setWallet] = useState<WalletOut | null>(null);

  useEffect(() => {
    if (isLogged) {
      getWallet().then(setWallet).catch(console.error);
    } else {
      setWallet(null);
    }
  }, [isLogged]);

  useEffect(() => {
    const handleAuthChange = () => {
      const token = localStorage.getItem('access_token');
      if (token) {
        getWallet().then(setWallet).catch(console.error);
      } else {
        setWallet(null);
      }
    };
    const handleBalanceChange = () => {
      const token = localStorage.getItem('access_token');
      if (token) {
        getWallet().then(setWallet).catch(console.error);
      }
    };
    window.addEventListener('auth-changed', handleAuthChange);
    window.addEventListener('balance-changed', handleBalanceChange);
    return () => {
      window.removeEventListener('auth-changed', handleAuthChange);
      window.removeEventListener('balance-changed', handleBalanceChange);
    };
  }, []);

  return (
    <header 
      className={`px-4 h-[56px] flex items-center gap-2 transition-colors duration-200 ${
        isWhite ? 'bg-[#f5f6f6] text-gray-900' : 'text-white'
      }`}
      style={!isWhite ? { backgroundImage: 'var(--bg-brand-gradient-vertical)' } : undefined}
    >
      {/* Left section: Back button or Logo */}
      <div className="flex items-center flex-shrink-0">
        {onBack ? (
          <button onClick={onBack} className={`p-1 -ml-1 cursor-pointer ${isWhite ? 'text-gray-800' : 'text-white'}`}>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        ) : (
          <div className="cursor-pointer select-none" onClick={() => onNavigate?.('home')}>
            <img src="/tip24beth.svg" alt="Tip24" className="h-8 object-contain" style={isWhite ? { filter: 'brightness(0)' } : undefined} />
          </div>
        )}
      </div>

      {/* Center section: Title */}
      {isWhite ? (
        <div className="font-bold text-base text-gray-900 truncate">
          {title}
        </div>
      ) : (
        <nav className="hidden md:flex gap-8 font-black text-[13px] uppercase tracking-wider h-full">
          <button
            onClick={() => onNavigate?.('home')}
            className={`h-[64px] border-b-4 transition-all ${
              activePage === 'home' || !activePage ? 'border-white opacity-100' : 'border-transparent opacity-70 hover:opacity-100'
            }`}
          >
            Sportwetten
          </button>
          <button
            onClick={() => onNavigate?.('live')}
            className={`h-[64px] border-b-4 transition-all ${
              activePage === 'live' ? 'border-white opacity-100' : 'border-transparent opacity-70 hover:opacity-100'
            }`}
          >
            Livewetten
          </button>
          <button className="h-[64px] border-b-4 border-transparent opacity-70 hover:opacity-100 transition-all">
            Casino
          </button>
        </nav>
      )}

      {/* Right section: Anmelden / Login / Balance */}
      <div className="ml-auto flex items-center justify-end flex-shrink-0">
        {isLogged ? (
          <button onClick={() => onNavigate?.('account')} className={`flex flex-col items-center justify-center rounded px-3 py-1 transition cursor-pointer ${isWhite ? 'bg-gray-100 hover:bg-gray-200' : 'bg-black/20 hover:bg-black/30'}`}>
            <span className={`text-[11px] leading-tight tracking-wide ${isWhite ? 'text-gray-600' : 'text-white/90'}`}>Einzahlung</span>
            <span className={`text-[13px] font-bold leading-tight mt-0.5 ${isWhite ? 'text-gray-900' : 'text-white'}`}>
              {wallet ? `${parseFloat(wallet.available_cash).toFixed(2).replace('.', ',')} €` : '0,00 €'}
            </span>
          </button>
        ) : (
          <div className="flex items-center gap-2">
            <button
              onClick={onLoginClick}
              className={`font-bold px-3 py-1.5 rounded-full text-[13px] transition uppercase tracking-wide ${
                isWhite ? 'text-gray-800 hover:bg-gray-100' : 'text-white border border-white/30 hover:border-white bg-black/10'
              }`}
            >
              Anmelden
            </button>
            {onRegisterClick && (
              <button
                onClick={onRegisterClick}
                className={`font-bold px-3 py-1.5 rounded-full text-[13px] transition uppercase tracking-wide ${
                  isWhite ? 'bg-[#c8102e] text-white hover:bg-red-700' : 'bg-white text-[#c8102e] hover:bg-gray-100'
                }`}
              >
                Registrieren
              </button>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
